import { Observable, catchError } from 'rxjs';
import { AbstractCrudApiService } from '@shared/abstracts/abstract-crud-api.service';
import { SessionReferencesDto } from '@shared/dto';
import { urlJoin } from '@shared/utils/url.utils';

export abstract class AbstractSessionService<Model, CreateDto, UpdateDto> extends AbstractCrudApiService<Model, CreateDto, UpdateDto> {

  override get endpoint(): string {
    return `${this.api$.value}/:sessionId`;
  }

  protected constructor(
  ) {
    super();
    this.api$.next(urlJoin(this.env.get('api.base'), 'sessions'));
    this.logger.debug(this.name, 'Endpoint', this.endpoint);
  }

  /** True when a session with the given title already exists (backend `uniqueSession` check). */
  validateTitle(title: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.url()}/validate-title?title=${encodeURIComponent(title)}`);
  }

  /**
   * What an edit to this session would reach: how many scheduled events it would
   * rewrite (`updatable`), what it would leave alone (`frozen`), and who else is
   * involved. A pure read — it changes nothing. Drives the confirmation dialog that
   * a 428 (`SESSION.UPDATE_REQUIRES_CONFIRMATION`) on `update()` demands.
   */
  references(sessionId: number): Observable<SessionReferencesDto> {
    return this.http.get<SessionReferencesDto>(`${this.url({ sessionId })}/references`).pipe(
      catchError((error) => this.handleHttpErrorResponse(error)),
    );
  }
}
